export const MENU_PAPER_WIDTH = 223;
